export default __webpack_public_path__ + "static/media/notifications.3b9738e2.svg";